export class DEFAULT_FUNCTIONS {
  public static readonly TIME = [
    {
      title: 'Ramp Loading',
      functionDefault: true,
      ramp: 0.0,
      interpolationType: 'TIME_FUNCTION.LINEAR_INTERPOLATION',
      points: [
        {
          x: 0.0,
          y: 0.0,
        },
        {
          x: 1.0,
          y: 0.0,
        },
        {
          x: 11.0,
          y: 1.0,
        },
      ],
    },
    {
      title: 'Constant Loading',
      functionDefault: true,
      ramp: 0.0,
      interpolationType: 'TIME_FUNCTION.LINEAR_INTERPOLATION',
      points: [
        {
          x: 0.0,
          y: 1,
        },
        {
          x: 1.08e4,
          y: 1,
        },
      ],
    },
  ];

  public static readonly DISPLACEMENT = [
    {
      title: 'DispFunc',
      functionDefault: true,
      interpolationType: 'DISPLACEMENT_FUNCTION.LINEAR_INTERPOLATION',
      points: [
        {
          x: -100.0,
          y: -100.0,
        },
        {
          x: 0.0,
          y: 0.0,
        },
        {
          x: 100.0,
          y: 100.0,
        },
      ],
    },
  ];

  public static readonly ROTATIONAL = [
    {
      title: 'RotaFunc',
      internalId: 102,
      functionDefault: true,
      interpolationType: 'ROTATIONAL_FUNCTION.LINEAR_INTERPOLATION',
      points: [
        {
          x: -114.592,
          y: -114.592,
        },
        {
          x: 0.0,
          y: 0.0,
        },
        {
          x: 114.592,
          y: 114.592,
        },
      ],
    },
    {
      title: 'FJStiffDef',
      functionDefault: true,
      interpolationType: 'ROTATIONAL_FUNCTION.LINEAR_INTERPOLATION',
      points: [
        {
          x: -114.592,
          y: 1.0,
        },
        {
          x: 0.0,
          y: 1.0,
        },
        {
          x: 114.592,
          y: 1.0,
        },
      ],
    },
  ];

  public static readonly TEMPERATURE = [
    {
      title: 'TempFunc',
      functionDefault: true,
      interpolationType: 'TEMPERATURE_FUNCTION.LINEAR_INTERPOLATION',
      points: [
        {
          x: 0.0,
          y: 0.0,
        },
        {
          x: 500.0,
          y: 0.0,
        },
      ],
    },
  ];
}
